import script from "./psiCashIncomeStastics.vue?vue&type=script&setup=true&lang=js"
export * from "./psiCashIncomeStastics.vue?vue&type=script&setup=true&lang=js"

import "./psiCashIncomeStastics.vue?vue&type=style&index=0&id=ee4fb2ea&scoped=true&lang=css"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee4fb2ea"]])

export default __exports__